import _isPlainObject from 'lodash/isPlainObject';

export const StatusBar = {
  name: 'StatusBar',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  render(el) {
    const { class: className, variant } = this.status;
    const args = {
      class: className || 'text-left text-md-center',
      props: {
        show: true,
        variant,
      },
    };
    return el('b-alert', args, [ this.message, this.modal ]);
  },
  computed: {
    message() {
      const { message } = this.status;
      if (_isPlainObject(message) && message.key) {
        /* eslint-disable vue-i18n/no-dynamic-keys */
        const { key, ...values } = message;
        return this.$t(key, { ...values });
      } else if (typeof message === 'string') {
        return message;
      }
    },
    modal() {
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Statuses.js